<template>
  <div class="">
    <div class="top-search-box">
      <topTab :rout="rout"></topTab>
    </div>
    <div class="content">
    <div class="header">
      <div class="wealth">
        <p>
          我的财富值：<span>{{ data.wealth_value }}</span>
        </p>
      </div>
      <div class="echart">
        <van-circle
          size="80"
          v-model="fortune"
          :rate="50"
          :speed="100"
          color="#4FD9D5"
          stroke-width="80"
          layer-color="#EFEFEF"
          text="4.7"
        />
        <div class="echart-line"></div>
        <div>
          <div class="progress">
            <span class="progress-title">爱情</span>
            <div class="progress-line">
              <div class="progress-line-c" :style="`width:${data.love}%`"></div>
            </div>
            <span class="progress-num">{{ data.love }}</span>
          </div>
          <div class="progress" style="margin: 0.44rem 0">
            <span class="progress-title">婚姻</span>
            <div class="progress-line">
              <div
                class="progress-line-c"
                :style="`background:#F398A8;width:${data.marriage}%;`"
              ></div>
            </div>
            <span class="progress-num">{{ data.marriage }}</span>
          </div>
          <div class="progress">
            <span class="progress-title">财富</span>
            <div class="progress-line">
              <div
                class="progress-line-c"
                :style="`background:#EEDC84;width:${data.wealth}%;`"
              ></div>
            </div>
            <span class="progress-num">{{ data.wealth }}</span>
          </div>
        </div>
      </div>

      <div class="sx">
        <div>
          <div class="l">
            <p>生肖</p>
            <p>生肖贵人</p>
          </div>
          <div class="r">
            <p>：{{ data.animal }}</p>
            <div>：{{ data.grArrFont }}</div>
          </div>
        </div>
        <div>
          <div class="l">
            <p>星座</p>
            <p>冲害刑克</p>
          </div>
          <div class="r">
            <p>：{{ data.constellation }}座</p>
            <p>：{{ data.ckArrFont }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="content-text">
      <div class="modular">
        <div class="title">
          <div class="title-line"></div>
          <div>五行八字</div>
        </div>
      </div>
      <div class="wx">
        <div
          class="echarts"
          id="myecharts"
          style="width: 2.8rem; height: 2.8rem"
        ></div>
        <div class="color-block">
          <div v-for="(item, index) in wx" :key="index">
            <div
              class="block"
              :style="`background:${item.itemStyle.color}`"
            ></div>
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>

      <div class="td">
        <div class="td-title">
          <div>时间</div>
          <div>年柱</div>
          <div>月柱</div>
          <div>日柱</div>
          <div>时柱</div>
        </div>
        <div class="tg">
          <div class="row-title">天干</div>
          <div class="td-i" :style="data.year1c">{{ data.year1 }}</div>
          <div class="td-i" :style="data.month1c">{{ data.month1 }}</div>
          <div class="td-i" :style="data.day1c">{{ data.day1 }}</div>
          <div class="td-i" :style="data.time1c">{{ data.time1 }}</div>
        </div>
        <div>
          <div class="row-title">地支</div>
          <div class="td-i" :style="data.year2c">{{ data.year2 }}</div>
          <div class="td-i" :style="data.month2c">{{ data.month2 }}</div>
          <div class="td-i" :style="data.day2c">{{ data.day2 }}</div>
          <div class="td-i" :style="data.time2c">{{ data.time2 }}</div>
        </div>
      </div>

      <div class="modular">
        <div class="title">
          <div class="title-line"></div>
          <div class="modular-title">日元</div>
        </div>
        <div class="txt" v-html="data.yen"></div>
      </div>
      <div class="modular">
        <div class="title">
          <div class="title-line"></div>
          <div class="modular-title">生肖</div>
        </div>
        <div class="txt" v-html="data.born"></div>
      </div>
      <div class="modular">
        <div class="title">
          <div class="title-line"></div>
          <div class="modular-title">夫妻宫</div>
        </div>
        <div class="txt" v-html="data.spouse"></div>
      </div>
    </div>

    <div class="user-date" @click="$router.push('/home?to=1')">
      <span
        >阳历生日 {{ data.birthday }}({{ sex == 1 ? "男" : "女" }})</span
      >
      <i class="iconfont icon-bianji"></i>
    </div>

    <div class="tips">
      温馨提示：本测算仅供参考，切勿过于当真。
    </div>

    <div class="btns">
      <div class="share" @click="shareMask = true">分享</div>
      <div class="zx" @click="goto">
        找老师咨询
      </div>
    </div>
    <share
      v-show="shareMask"
      :type="3"
      :des="des"
      @closeShareMask="closeShareMask"
    ></share>
    <shareBottomComp v-if="sharePop == 1"></shareBottomComp>
    </div>
  </div>
</template>

<script>
/**
@description:五行分析
@createTime:2021-08-25
@create:wq
*/
import { Circle as VanCircle } from "vant";
import share from "../../../components/share.vue";
import * as echarts from "echarts";
import { getCode ,shareJsSdk,getQueryString} from "@/utils/tool";
import topTab from "@/components/topTab";
import { qywx} from "@/utils/tool";
export default {
  name: "",
  props: {},
  components: { VanCircle, share ,topTab},
  data() {
    return {
      fortune: 50,
      wx: [],
      data: {},
      shareMask: false,
      des:'',
      sex:'',
      sharePop:0,
      rout:[{
        name:'首页',
        path:'/home'
      },{
        name:'五行分析',
      }]
    };
  },
  computed: {},
  watch: {},
  created() {
    getCode();
    this.sex = getQueryString('sex');
    this.getData();
    if (getQueryString("share")) {
      this.sharePop = 1;
    } else {
      this.sharePop = 0;
    }
  },

  mounted() {},
  methods: {
    goto(){
      window.location = qywx
    },
    closeShareMask() {
      this.shareMask = false;
    },
    getData() {
      this.api.fiveElementsInfo({year:getQueryString('date'),
      lune:getQueryString('lune'),time:getQueryString('time')})
      .then((res) => {
        let myChart = echarts.init(document.getElementById("myecharts"));
        let data = res.data;
        this.data = res.data;
        this.data.grArrFont = this.data.grArr.join("、");
        this.data.ckArrFont = this.data.ckArr.join("、");
        this.getDataColor();
        this.wx = [
          {
            value: data.gold,
            name: "金",
            itemStyle: { color: "#EEDC84" },
          },
          {
            value: data.wood,
            name: "木",
            itemStyle: { color: "#F9BD77" },
          },
          {
            value: data.water,
            name: "水",
            itemStyle: { color: "#77E0F1" },
          },
          {
            value: data.fire,
            name: "火",
            itemStyle: { color: "#EF91A1" },
          },
          {
            value: data.soil,
            name: "土",
            itemStyle: { color: "#CBA48A" },
          },
        ];
        var option;
        option = {
          //   tooltip: {
          //     trigger: "item",
          //   },

          //   legend: {
          //     show: false,
          //   },
          series: [
            {
              //   name: "访问来源",
              type: "pie",
              radius: "100%",
              label: {
                show: false,
              },
              legendHoverLink: false,
              data: this.wx,
              emphasis: {
                scale: false,
                scaleSize: 0,
                // itemStyle: {
                //   shadowBlur: 0,
                //   shadowOffsetX: 0,
                //   //   shadowColor: "rgba(0, 0, 0, 0.5)",
                // },
              },
            },
          ],
        };
        shareJsSdk('wx','五行分析')

        myChart.setOption(option);
      });
    },
    getDataColor() {
      //#F9BD77 -甲乙寅卯   #EF91A1-丙丁巳午  #CBA48A-戊己辰戌丑未；
      //#EEDC84 -庚辛申酉   #77E0F1-壬癸亥子
      let d = this.data;
      d.year1c = this.colorSet(d.year1);
      d.month1c = this.colorSet(d.month1);
      d.day1c = this.colorSet(d.day1);
      d.time1c = this.colorSet(d.time1);
      d.year2c = this.colorSet(d.year2);
      d.month2c = this.colorSet(d.month2);
      d.day2c = this.colorSet(d.day2);
      d.time2c = this.colorSet(d.time2);
      let a = "戊";
      let b = "戊己辰戌丑未";
      console.log(b.indexOf(a), 999);
    },
    colorSet(d) {
      let c;
      let f = "color:";
      let arr = [
        {
          font: "甲乙寅卯",
          color: "#F9BD77",
        },
        {
          font: "丙丁巳午",
          color: "#EF91A1",
        },
        {
          font: "戊己辰戌丑未",
          color: "#CBA48A",
        },
        {
          font: "庚辛申酉",
          color: "#EEDC84",
        },
        {
          font: "壬癸亥子",
          color: "#77E0F1",
        },
      ];
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].font.indexOf(d) >= 0) {
          c = arr[i].color;
          break;
        }
      }
      return f + (c ? c : "#000");
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  overflow: hidden;
}
.header {
  margin: 0.34rem 0.4rem;
}
.wealth {
  font-size: 0.3rem;
  font-weight: 400;
  color: #666666;
  text-align: center;
  span {
    color: #4fd9d5;
  }
}
.echart {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.5rem;
  .echart-line {
    width: 1px;
    height: 0.84rem;
    background: #f0f0f0;
  }
}

.progress {
  display: flex;
  align-items: center;
  > span {
    font-size: 0.22rem;
    font-family: PingFang-SC-Medium;
    color: #999999;
  }
  //   .progress-title {
  //   }
  .progress-line {
    margin: 0 0.1rem;
    height: 0.2rem;
    width: 3.14rem;
    background: #e6e6e6;
    border-radius: 0.1rem;
    overflow: hidden;
    .progress-line-c {
      height: 100%;
      width: 50%;
      background: #f398cc;
      border-radius: 0.1rem;
    }
  }
  //   .progress-num {
  //   }
}
.sx {
  margin-top: 0.5rem;
  display: flex;

  font-size: 0.28rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  p {
    margin-bottom: 0.12rem;
  }
  > div {
    flex: 1;
    // width: 50%;
    display: flex;
  }
  .l {
    text-align: justify;
    // text-align-last: justify;
    // text-justify: distribute-all-lines;
  }
}

.content-text {
  overflow: hidden;
  .modular {
    margin: 0.2rem 0.24rem;
  }
}
.title {
  font-size: 0.32rem;
  color: #333333;
  font-weight: bold;
  display: flex;

  .title-line {
    // margin-top: 4px;
    width: 0.08rem;
    height: 0.34rem;
    background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
    border-radius: 0px 2px 2px 0px;
    margin-right: 0.22rem;
  }
  .modular-title {
    line-height: 0.34rem;
  }
}
.txt {
  font-size: 0.24rem;
  color: #999999;
  margin-top: 0.16rem;
}

.wx {
  margin-top: 0.7rem;

  display: flex;
  //   align-items: center;
  justify-content: center;
  .echarts {
    margin-right: 1.6rem;
  }
  .color-block {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    > div {
      display: flex;
      align-items: center;
    }
    .block {
      background: cornflowerblue;
      width: 0.44rem;
      height: 0.2rem;
      border-radius: 0.1rem;
      margin-right: 0.12rem;
    }
  }
  span {
    font-size: 0.28rem;
    font-family: PingFang-SC-Medium;
    color: #999999;
  }
}
.td {
  margin: 0.46rem 0.24rem;
  font-size: 0.28rem;
  font-weight: 400;

  > div {
    display: flex;
    > div {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 0.6rem;
      //   padding: 0.12rem 0;
      box-sizing: border-box;
    }
  }
  .td-title {
    font-weight: bold;
    color: #666666;
  }
  .row-title {
    color: #cccccc;
  }
  .td-i {
    background: rgba($color: #4fd9d5, $alpha: 0.1);
  }
  .tg {
    .td-i {
      position: relative;

      &::before {
        content: "";
        position: absolute;
        right: 0;
        width: 1px;
        height: 0.4rem;
        background: #e6e6e6;
      }
      &:last-child:before {
        width: 0;
      }
    }
  }
}

.user-date {
  height: 0.8rem;
  background: #f0f0f0;

  font-size: 0.3rem;
  font-weight: 400;
  color: #666666;
  display: flex;
  align-items: center;
  justify-content: center;
  i {
    margin-left: 0.2rem;
    font-size: 0.3rem;
    margin-top: 4px;
  }
}
.tips {
  font-size: 0.24rem;
  font-weight: 400;
  color: #f9647d;
  margin: 0.46rem 0.24rem 0.28rem;
  span {
    color: #e5af30;
  }
  //   text-decoration: underline;
}
.btns {
  margin: 0.28rem 0.24rem 0.46rem;
  font-size: 0.3rem;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: space-between;
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.54rem;
    width: 3.38rem;
    height: 0.88rem;
    box-sizing: border-box;
  }
  .share {
    border: 1px solid #4fd9d5;
    color: #4fd9d5;
  }
  .zx {
    background: #4fd9d5;
    color: white;
  }
}
</style>
